import ProjectMapConfig from './ProjectMapConfig'

export default ProjectMapConfig
